module.exports = __webpack_public_path__ + "img/atm.e1b3ab3b.svg";